// @ts-nocheck
if(!customElements.get('variant-extension')) {
    class VariantExtension extends HTMLElement {
        constructor() {
            super();
            this.accessToken = atob(this.dataset.sectionId?.replace('section-id-',''));
            this.variantIdChangedUnsubscriber = undefined;
            this.metaObjectsData = [];
            this.variantDataCache = null;
            this.imagesDataCache = null;
            this.lastPathname = '';
            this.variantId = '';
            this.ProductStyleData = null;
        }
        async connectedCallback() {
            await this._queryHandle();
            await this._initVariantData();
            this.onVariantChangeUnsubscriber = subscribe(
                PUB_SUB_EVENTS.variantChanged,
                this._changeVariantSelected.bind(this)
            );
            this.onVariantStyleChangedUnsubscriber = subscribe(
                PUB_SUB_EVENTS.variantStyleChanged,
                this._variantStyleChanged.bind(this)
            );
            this.onVariantIdChangedUnsubscriber = subscribe(
                PUB_SUB_EVENTS.variantIdChanged,
                this._variantIdChanged.bind(this)
            );
            this._initVariantSelected();
            this.addEventListener('click', event => {
                if(event.target.closest('label')) {
                    if(event.target.closest('label').dataset.galleryImage) {
                        publish(PUB_SUB_EVENTS.galleryImageChanged, {
                            data: {
                                galleryImage: event.target.closest('label')?.dataset.galleryImage
                            },
                        });
                    }
                    this.labelSelected.innerHTML = event.target.closest('label')?.dataset.labelHtml;           
                }
               if (event.target.closest('input')) {
                    const existing = document.getElementById('custom-input-properties');
                    if (existing) existing.remove();

                    const form = document.querySelector('form[data-type="add-to-cart-form"]');
                    if (form) {
                        const newInput = document.createElement('input');
                        newInput.name = event.target.closest('input').name;
                        newInput.type = 'hidden';
                        newInput.value = event.target.closest('input').value;
                        newInput.id = 'custom-input-properties';

                        form.append(newInput);
                    }
                }
            });
        }
        async _initVariantData() {
                try {
                    await fetch(`${window.location.pathname}.json`)
                    .then(response => response.json())
                    .then(data => {
                        this.variantDataCache = data?.product?.variants;
                        this.imagesDataCache = data?.product?.images;
                    })
                } catch (err) {
                    console.error('Fetch error:', err);
                    return;
                }
        }
        async _queryHandle() {
            const query = `{
                    border_options: metaobjects(first: 20, type: "variant_options_extension_border_options") {
                        nodes {
                            title: field(key: "title") {
                                value
                            }
                            color: field(key: "color") {
                                value
                            }
                            mirror: field(key: "mirror") {
                                value
                            }
                        }
                    }
                    product(id: "gid://shopify/Product/${this.dataset.productId}") {
                        metafield(namespace: "custom", key: "style_options") {
                        references(first: 20) {
                            nodes {
                                ... on Metaobject {
                                    label: field(key: "label") {
                                        value
                                    }
                                    image: field(key: "image") {
                                        reference {
                                            ... on MediaImage {
                                                image {
                                                    altText
                                                    url
                                                }
                                            }
                                        }
                                    }
                                    label_html: field(key: "label_html") {
                                            value
                                        }
                                    }
                                }
                            }
                        }
                    }
                }`;    
            try {
                const response = await fetch('/api/2025-01/graphql.json', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': this.accessToken,
                    },
                    body: JSON.stringify({ query })
                });
                const results = await response.json();
                this.ProductStyleData = results?.data?.product?.metafield?.references?.nodes;
                PUB_SUB_BORDER_OPTIONS = results?.data?.border_options?.nodes;
            } catch (error) {
                console.error('Error fetching metaobjects:', error);
            };
        }
        async _initVariantSelected() {
            const labelSelected = document.querySelector('[data-option-handle="style"] legend');
            labelSelected && (labelSelected.innerHTML = '');
            // Get full query parameters object
            const params = new URLSearchParams(window.location.search);
            // Get specific parameter values
            this.variantId = params.get('variant');
            if(!this.variantId) {
                const selectedVariant = this.variantDataCache[0];
                let index = 0;
                const matBorderSelected = document.querySelector('[data-option-handle="border-mat-options"] input:checked');
                const matBorderHandle = matBorderSelected ? matBorderSelected.value.toLowerCase().replaceAll(' ', '-') : null;
                const StyleData = matBorderHandle ? this.ProductStyleData.filter(style => style.image.reference.image.url.includes('with-mat')) : this.ProductStyleData;
                for(const style of StyleData) {
                    const frameStyleInput = document.querySelectorAll('[data-option-handle="style"] input');
                    const foundFrame = Array.from(frameStyleInput).find(frame => style?.label?.value.includes(frame.value));
                    const foundFrameLabel = foundFrame?.nextElementSibling;
                    foundFrameLabel && foundFrameLabel.style.setProperty('--swatch-background',`url(${style?.image?.reference?.image?.url})`);
                    const labelHtml = JSON.parse(style?.label_html?.value);
                    const htmlOutput = this._renderRichText(labelHtml);
                    const appendStepInnerHtml = htmlOutput.replace('<p><strong>', `<p><strong><span class="step-name">Step ${labelSelected.dataset.step}:</span> `);
                    foundFrame && (foundFrame.dataset.htmlOutput = appendStepInnerHtml);
                    if(index === 0) {
                        labelSelected.innerHTML = appendStepInnerHtml;
                    }
                    index++;           
                }
            } else {
                const selectedVariant = this.variantDataCache.find(variant => parseInt(variant.id) === parseInt(this.variantId));
                let index = 0;
                const matBorderSelected = document.querySelector('[data-option-handle="border-mat-options"] input:checked');
                const matBorderHandle = matBorderSelected ? matBorderSelected.value.toLowerCase().replaceAll(' ', '-') : null;
                const StyleData = matBorderHandle ? this.ProductStyleData.filter(style => style.image.reference.image.url.includes(matBorderHandle)) : this.ProductStyleData;
                for(const style of StyleData) {
                    const frameStyleInput = document.querySelectorAll('[data-option-handle="style"] input');
                    const foundFrame = Array.from(frameStyleInput).find(frame => style?.label?.value.includes(frame.value));
                    const foundFrameLabel = foundFrame?.nextElementSibling;
                    foundFrameLabel && foundFrameLabel.style.setProperty('--swatch-background',`url(${style?.image?.reference?.image?.url})`);
                    const labelHtml = JSON.parse(style?.label_html?.value);
                    const htmlOutput = this._renderRichText(labelHtml);
                    const appendStepInnerHtml = htmlOutput.replace('<p><strong>', `<p><strong><span class="step-name">Step ${labelSelected.dataset.step}:</span> `);
                    foundFrame && (foundFrame.dataset.htmlOutput = appendStepInnerHtml);
                    if(index === 0) {
                        labelSelected.innerHTML = appendStepInnerHtml;
                    }
                    index++;
                }
            }
            const borderWraper = document.querySelector('[data-option-handle="border-options"]');
            const optionStyleInput = document.querySelector('[data-option-handle="style"] input:checked');
            const cartBorderOption = document.querySelector('[ref="border_option"]');
            const borderWraperInput = document.querySelector('[data-option-handle="border-options"] input:checked');             
            if(optionStyleInput.value === 'Stretched Canvas') {
                cartBorderOption.name = 'properties[Border Option]';
                cartBorderOption.value = borderWraperInput.value;
                borderWraper && borderWraper.classList.add('active');
            } else {
                cartBorderOption.name = 'property[Border Option]';
                borderWraper && borderWraper.classList.remove('active');
            }
        }
        _changeVariantSelected({data: {event}}) {
            const frameStyleInputs = event.target.querySelectorAll('[data-option-handle="style"] input[data-option-available="true"]');
            if(frameStyleInputs.length > 0) {
                frameStyleInputs[0].click();
            }               
        }
        _variantStyleChanged() {
            const labelSelected = document.querySelector('[data-option-handle="style"] legend');
            const frameTypeInput = document.querySelector('[data-option-handle="frame-type"] input:checked, [data-option-handle="orientation"] input:checked');
            const frameStyleInputs = document.querySelectorAll('[data-option-handle="style"] input[data-option-available="true"]');
            if(frameStyleInputs.length > 0) {
                let index = 0;
                const matBorderSelected = document.querySelector('[data-option-handle="border-mat-options"] input:checked');
                const matBorderHandle = matBorderSelected ? matBorderSelected.value.toLowerCase().replaceAll(' ', '-') : null;
                const StyleData = matBorderHandle ? this.ProductStyleData.filter(style => style.image.reference.image.url.includes('with-mat')) : this.ProductStyleData;
                for(const style of StyleData) {
                    const foundFrame = Array.from(frameStyleInputs).find(input => style?.label?.value.includes(input.value));
                    if(foundFrame?.nextElementSibling) {
                        const foundFrameLabel = foundFrame?.nextElementSibling;
                        foundFrameLabel && foundFrameLabel.style.setProperty('--swatch-background',`url(${style?.image?.reference?.image?.url})`);
                        const labelHtml = JSON.parse(style?.label_html?.value);
                        const htmlOutput = this._renderRichText(labelHtml);
                        const appendStepInnerHtml = htmlOutput.replace('<p><strong>', `<p><strong><span class="step-name">Step ${labelSelected.dataset.step}:</span> `);
                        foundFrame && (foundFrame.dataset.htmlOutput = appendStepInnerHtml);
                        foundFrameLabel && foundFrameLabel.style.setProperty('--swatch-background',`url(${style?.image?.reference?.image?.url})`);
                    }
                    index++;
                }
            };
        }
        _renderRichText(node) {
            if (!node) return '';

            if (node.type === 'root') {
                return node.children.map(child => this._renderRichText(child)).join('');
            }

            if (node.type === 'paragraph') {
                const inner = node.children.map(child => this._renderRichText(child)).join('');
                return `<p>${inner}</p>`;
            }

            if (node.type === 'text') {
                const text = node.value || '';
                if (node.bold) return `<strong>${text}</strong>`;
                return text;
            }

            return '';
        }
        _variantIdChanged({ data: { event }}) {
            const optionStyle = event.target.closest('[data-option-handle="style"]');
            const borderWraper = document.querySelector('[data-option-handle="border-options"]');
            const optionBorder = event.target.closest('[data-option-handle="border-options"]');
            const optionStyleInput = document.querySelector('[data-option-handle="style"] input:checked');
            const orientation = document.querySelector('[data-option-handle="orientation"] input:checked');
            const borderOption = document.querySelector('[ref="border_option"]');
            const orientationLowerCase = orientation.value.toLowerCase();
            if(optionStyleInput.value === 'Stretched Canvas' || optionBorder) {
                borderWraper && borderWraper.classList.add('active');
                const borderWraperInput = document.querySelector('[data-option-handle="border-options"] input:checked');
                if(borderOption) {
                    borderOption.value = borderWraperInput.value
                    borderOption.name = 'properties[Border Option]';
                }
            } else {
                borderWraper && borderWraper.classList.remove('active');
                if(borderOption) {
                    borderOption.value = '';
                    borderOption.name = 'property[Border Option]';
                };
            }
            if(optionBorder) {                               
                const existing = PUB_SUB_ORIENTATION.find(o => o.orientation === orientationLowerCase);
                const borderWraperInput = event.target.value;
                if(existing) {
                   existing.borderWrap = borderWraperInput;
                }
            } else {
                const existing = PUB_SUB_ORIENTATION.find(o => o.orientation === orientationLowerCase);
                if(existing) {
                   const inputFound = document.querySelector(`[data-option-handle="border-options"] input[value="${existing.borderWrap}"]`);
                } else {
                   const inputFound = document.querySelector(`[data-option-handle="border-options"] input`);
                }
            }
            //border-mat-option
            if(event.target.closest('[data-option-handle="border-mat-options"]')) {
                const fieldsOption = event.target.closest('[data-option-handle="border-mat-options"]');
                const optionLabel = fieldsOption.querySelector('legend');
                optionLabel && (optionLabel.innerHTML = `<p><strong><span class="step-name">Step ${optionLabel.dataset.step}:</span> Mat Border: </strong>${event.target.value}</p>`);
                publish(PUB_SUB_EVENTS.borderMatChanged, {
                    data: {
                        event: event,
                        orientation: orientationLowerCase,
                        productStyleData: this.ProductStyleData
                    },
                });
            }

            const formPicker = event.target.closest('.variant-picker__form'); 
            const priceEl = document.querySelectorAll('.product-details [ref="priceContainer"] .price');
            const addToCartEl = document.querySelector('[ref="addToCartButton"]');
            const variantIdEl = document.querySelector('[ref="variantId"]');
            if(event.target.closest('[data-option-handle="orientation"]')) {
                const allInputs = formPicker?.querySelectorAll('[data-option-handle="size"] input, [data-option-handle="style"] input');
                const checkedOrientationInputs = formPicker?.querySelectorAll('[data-option-handle="orientation"] input[data-option-available="true"]:checked');   
                const variantOptionsMatched = this.variantDataCache.filter(variant => 
                    variant.title.includes(checkedOrientationInputs[0].value)
                );
                if(variantOptionsMatched.length > 0) {               
                    Array.from(allInputs).forEach(input => {
                        input.dataset.optionAvailable = false;
                        for(const option of variantOptionsMatched) {
                            const optionSplit = option.title.split(' / ');
                            if(optionSplit[0] === input.value || optionSplit[1] === input.value || optionSplit[2] === input.value) {
                                input.dataset.optionAvailable = true;
                                break;
                            }
                        }
                    })
                }
                const sizeAvailableInputs = formPicker?.querySelectorAll('[data-option-handle="size"] input[data-option-available="true"]');
                const styleAvailableInputs = formPicker?.querySelectorAll('[data-option-handle="style"] input[data-option-available="true"]');
                sizeAvailableInputs && sizeAvailableInputs[0].click();
                styleAvailableInputs && styleAvailableInputs[0].click();
            }
            const checkedInputs = formPicker?.querySelectorAll('.variant-option input[data-option-available="true"]:checked');
            let searchValues = [];
            Array.from(checkedInputs).forEach(input => {
                searchValues.push(input.value);
            });            
            
            const variantMatched = this.variantDataCache.find(variant =>
                searchValues.every(val => variant.title.includes(val))
            );
            let reformatPrice = null;
            if(variantMatched) {
                reformatPrice = new Intl.NumberFormat('en-AU', {style: 'currency', currency: `${variantMatched?.price_currency}`}).format(variantMatched?.price);
                if(priceEl.length > 0) {
                    priceEl.forEach(price => {
                        price.textContent = `${reformatPrice}`;
                    });                 
                };
                addToCartEl && (addToCartEl.disabled = false);
                variantIdEl && (variantIdEl.value = variantMatched.id);
                const getImagePosition = this.imagesDataCache.find(image => image.id === variantMatched?.image_id);
                const url = new URL(window.location.href);
                url.searchParams.set("variant", variantMatched.id);
                window.history.replaceState({}, "", url.toString());
                this._variantStyleChanged();
                this.variantId = variantMatched.id;
                const styleFieldset = event.target.closest('[data-option-handle="style"]');
                const styleLabel = styleFieldset?.querySelector('legend');
                styleLabel && event.target.dataset.htmlOutput && (styleLabel.innerHTML = event.target.dataset.htmlOutput); 
            }
             if(event.target.closest('[data-option-handle="style"]') || event.target.closest('[data-option-handle="orientation"]') || event.target.closest('[data-option-handle="border-options"]') || event.target.closest('[data-option-handle="border-mat-options"]')) {
                    publish(PUB_SUB_EVENTS.changedGalleryImage, {
                        data: {
                        event,
                        },
                    }); 
            }
        }
    }
    customElements.define('variant-extension', VariantExtension);
}